import { render, staticRenderFns } from "./Quartile.vue?vue&type=template&id=53304282"
import script from "./Quartile.vue?vue&type=script&lang=js"
export * from "./Quartile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports